import ExternalLink from '@/components/atoms/ExternalLink';
import React from 'react';

/**
 * 「解約画面」の重要事項制御コンポーネント。
 */
const QuitTextMobileVoice = () => {
  return (
    <div className='m-box-02'>
      <div className='m-text'>
        {/* 音声契約は MNP や音声付加サービス解約を伴うため、他契約種別より注意事項が多い。 */}
        <ul className='m-list'>
          <li className='m-list__item'>
            サービス開始月に解約された場合、1ヶ月分の月額料金を請求いたします。
          </li>
          <li className='m-list__item'>解約日は解約お申し込み月の末日となります。</li>
          <li className='m-list__item'>
            解約月も1ヶ月の月額料金がかかります（日割は行いません）。
          </li>
          <li className='m-list__item'>解約後に残っているチャージ分の返金はできません。</li>
          <li className='m-list__item'>
            音声をご利用の場合、本サービスの解約に伴いNUROモバイルでんわも解約となります。
          </li>
          <li className='m-list__item'>解約時は、プランを問わず解約金は発生しません。</li>
          <li className='m-list__item'>
            「NUROモバイル」内では、ドコモ回線（D）・ソフトバンク回線（S）・au回線（A）の間でのMNP転出・転入は出来ません。
          </li>
          <li className='m-list__item'>
            解約手続きを行った場合、契約変更など他のお手続きができなくなりますのでご注意ください。
          </li>
          <li className='m-list__item'>
            SIMカードは貸与品となります。解約後は、お手数ですがSIMカード返送先住所まで郵送もしくは宅配便にてご返却ください。なお、送料はお客さま負担となります。
          </li>
          <div style={{ marginLeft: '2em' }}>
            <ExternalLink href='https://support.sonynetwork.co.jp/faqsupport/nuromobile/web/knowledge2752.html'>
              SIMカード返送先住所
            </ExternalLink>
          </div>
          <li className='m-list__item'>誤返却物の取り扱いについて</li>
          <div style={{ marginLeft: '2em' }}>
            －当社のSIMをご返却される際には、お客さまの私物(以下、私物品)を誤って送付しないようご注意ください。
          </div>
          <div style={{ marginLeft: '2em' }}>
            －私物品については、当社到着後90日間経過したものは廃棄いたします。
          </div>
          <div style={{ marginLeft: '2em' }}>
            －私物品の紛失、破損等については一切責任を負いかねますので、あらかじめご了承ください。
          </div>
          <div style={{ marginLeft: '2em' }}>
            －私物品の返却に掛かる送料はお客さま負担となります。
          </div>
        </ul>
      </div>
      {/* 規約読了後に MNP 転出か月末解約かを選ばせるため、その前提をここで示す。 */}
      <div>解約お申し込みは下記規約類を必ずお読みになったうえで、お手続きください。</div>
      <br />
      <div>NUROモバイルに関する規約</div>
      <br />
      <div className='m-text'>
        <ul className='m-list'>
          <li className='m-list__item'>
            <ExternalLink href='https://mobile.nuro.jp/legal/postpaid/kiyaku.pdf'>
              ご利用規約
            </ExternalLink>
          </li>
        </ul>
      </div>
      <br />
      <div>ご確認いただけましたら、チェックボックスにチェックを入れていただいた上で、</div>
      <div>「MNP転出による解約」または「月末解約」をご選択ください。</div>
      <div>
        ※音声をご利用でお申し込み時に電話番号を新規取得された場合、ご利用開始日から8日間は、「MNP転出による解約」はできません。
      </div>
      <br />
      <div>※このページでは解約のお手続きは完了いたしません。</div>
    </div>
  );
};

export default QuitTextMobileVoice;
